/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

/**
 * BEM Classname Builder
 */
export class BEM {

	/** Classname as a string */
	public str: string;

	/** Modifiers */
	public modifiers?: Array<string>;

	/**
	 * BEM builder constructor
	 *
	 * @param block Block
	 * @param element Element
	 * @param modifiers Modifiers
	 */
	public constructor(
		public block: string,
		public element?: string,
		modifiers?: Array<string>|string
	) {

		this.modifiers = ( modifiers instanceof Array ? modifiers : modifiers ? [ modifiers ] : [] );

		this.str = (
			// Base class
			[ block + ( element ? "__" + element : "" ) ].concat(
				// Add modifiers
				this.modifiers.map((mod) =>
					block + ( element ? "__" + element : "" ) + "--" + mod
				)
			)
		).join(" ");

	}

	/**
	 * Returns a new BEM builder with changed element name
	 *
	 * @param element Element name
	 * @param preserveModifiers If to preserve modifiers
	 */
	public el(element: string, preserveModifiers: boolean = false) {

		return new BEM(this.block, element, preserveModifiers ? this.modifiers : []);

	}

	/**
	 * Returns a new BEM builder with additional modifiers
	 *
	 * @param modifiers New modifiers
	 * @param mergeModifiers If to merge with current modifiers
	 */
	public mod(modifiers: Array<string>|string, mergeModifiers: boolean = true) {

		return new BEM(this.block, this.element, mergeModifiers ? this.modifiers.concat(
			modifiers instanceof Array ? modifiers : modifiers ? [ modifiers ] : []
		) : modifiers);

	}

}
/**
 * Creates a new BEM builder
 *
 * @param block Block
 * @param element Element
 * @param modifiers Modifiers
 */
export function bem(
	block: string,
	element?: string,
	modifiers?: Array<string>|string
) {

	return new BEM(block, element, modifiers);

}
